import React, { useState, useEffect } from 'react'
import {
  MenuItem,
  FormControlLabel,
  Checkbox,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  Grid
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import useStyles from './styles'


const KeywordRule = (props) => {
  const {
    rule,
    removeRule,
    setIndex,
    ruleIndex,
    updateRule
  } = props

  const localClasses = useStyles()
  const [regRule, setRegRule] = useState(rule.regRule ? rule.regRule : 'START_WITH')
  const [text, setText] = useState(rule.text ? rule.text : '')
  const [isCaseSensitive, setIsCaseSensitive] = useState(rule.isCaseSensitive)


  useEffect(() => {
    updateRule(setIndex, ruleIndex, {regRule, text, isCaseSensitive})
  }, [regRule, text, isCaseSensitive]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleRuleChange = (event) => {
    setRegRule(event.target.value)
  }

  const handleTextChange = (event) => {
    setText(event.target.value)
  }

  const handleCaseSensitiveChange = (event) => {
    setIsCaseSensitive(event.currentTarget.checked)
  }

  const handleRemoveRuleClick = () => {
    if (removeRule) {
      removeRule(setIndex, ruleIndex)
    }
  }

  return (
    <div
      className={localClasses.rule}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={2} className={localClasses.domainsGrid}>
          <FormControl
            className={localClasses.regRule}
          >
            <InputLabel
              shrink
              color='secondary'
            >
              Condition
            </InputLabel>
            <Select
              input={<OutlinedInput notched label='Condition' />}
              value={regRule}
              onChange={handleRuleChange}
              variant='outlined'
              color='secondary'
            >
              <MenuItem value={'START_WITH'}>Start with</MenuItem>
              <MenuItem value={'EXACT'}>Exact match</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <DeleteIcon />
            }
            onClick={handleRemoveRuleClick}
            label='Delete'
            className={localClasses.remove}
            color='textSecondary'
          />
        </Grid>
        <Grid item xs={12} md={10} className={localClasses.domainsGrid}>
          <TextField
            label='Keywords'
            variant='outlined'
            color='secondary'
            className={localClasses.ruleInput}
            onChange={handleTextChange}
            value={text}
            placeholder='Write down the keywords separating them with a comma...'
            InputLabelProps={{
              shrink: true,
              required: false
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isCaseSensitive}
                onChange={handleCaseSensitiveChange}
              />
            }
            label='Case sensitive'
            className={localClasses.checkbox}
            color='secondary'
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default KeywordRule
